import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DraftPeriod from './view/draft-period';

const DraftPeriodRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DraftPeriod />} />
  </ErrorBoundaryRoutes>
);

export default DraftPeriodRoutes;
